import * as XLSX from "xlsx";

const fmt = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }); }
  catch { return iso; }
};

const fmtOra = (iso) => {
  const s = String(iso || "");
  return s.length >= 16 ? s.slice(11, 16) : "";
};

/**
 * Esporta i gruppi filtrati in un file Excel (.xlsx).
 * @param {Array} groups - gruppi già filtrati ({ commessa_name, clienti: [] })
 * @param {string} filenameBase - nome file senza estensione
 * @param {Object} squadreMap - mappa { squadra_id: nome }
 */
export function exportPianificatiToExcel(groups, filenameBase, squadreMap = {}) {
  const rows = [];
  (groups || []).forEach((g) => {
    (g.clienti || []).forEach((c) => {
      const dp = c.data_pianificazione || c.planned_at;
      rows.push({
        "Commessa": g.commessa_name || "",
        "ID Cliente": c.cliente_id || "",
        "Nome": c.nome || "",
        "Cognome / Ragione sociale": c.cognome_ragione_sociale || "",
        "Telefono": c.telefono || "",
        "Indirizzo": c.indirizzo || "",
        "Città": c.citta || "",
        "Provincia": c.provincia || "",
        "Regione": c.regione || "",
        "Data pianificato": fmt(dp),
        "Ora": fmtOra(c.data_pianificazione),
        "Squadra": squadreMap[c.squadra_id] || "",
        "Pianificato da": c.planned_by_name || "",
        "Note": (c.notes || []).map((n) => n.text).join(" | "),
      });
    });
  });
  if (rows.length === 0) rows.push({ "Commessa": "Nessun dato" });

  const ws = XLSX.utils.json_to_sheet(rows);
  ws["!cols"] = [
    { wch: 22 }, { wch: 12 }, { wch: 16 }, { wch: 26 }, { wch: 14 },
    { wch: 26 }, { wch: 18 }, { wch: 10 }, { wch: 16 }, { wch: 16 },
    { wch: 8 }, { wch: 18 }, { wch: 20 }, { wch: 40 },
  ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Pianificati");
  const stamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `${filenameBase}_${stamp}.xlsx`);
}
